import axios from 'axios';

import { reportError } from '@/integrations/sentry/errorReporting';
import { PlutoClientException } from '@/PlutoClientException';

export type UserMutationOperation = 'create-user' | 'update-user' | 'resend-invitation';

type UserMutationErrorHandlerOptions = {
  operation: UserMutationOperation;
  showNotification: (severity: 'error', message: string) => void;
  t: (key: string) => string;
};

export function createUserMutationErrorHandler({ operation, showNotification, t }: UserMutationErrorHandlerOptions) {
  return (error: unknown) => {
    if (error instanceof PlutoClientException) {
      if (error.statusCode === 403) {
        showNotification('error', t('error.api.err_forbidden'));
      }
      return;
    }

    if (axios.isAxiosError(error)) {
      return;
    }

    showNotification('error', t('error.api.unknown'));
    reportError(error, { feature: 'user-access-control', operation });
  };
}
